import CustomInputAdornment from "./CustomInputAdornment";

export default CustomInputAdornment;